export function loadFileAsArrayBuffer(file) {
  return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => {
          const data = reader.result;
          resolve(data);
      }
      reader.readAsArrayBuffer(file);
  });
}

export function loadFileAsText(file) {
  return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => {
          const data = reader.result;
          resolve(data);
      }
      reader.readAsText(file);
  });
}

export function convertFileListToArray(list = null) {
  const results = [];
  if (!list) return results;
  for (let i = 0; i < list.length; i++)
      results.push(list[i]);
  return results;
}